const scrolledIntoViewRef = (element: HTMLElement) => {
  element?.scrollIntoView({ block: "nearest" });
};

const createSelectOptionRef = (shouldScrollIntoView = false) =>
  shouldScrollIntoView ? scrolledIntoViewRef : undefined;

export default createSelectOptionRef;
